import React, { lazy } from "react";
import Loadable from "../../components/Loadable";
import config from "./config";
const List = Loadable(lazy(() => import("./AbmComponents/List")));
const Update = Loadable(lazy(() => import("./AbmComponents/Update")));
const Show = Loadable(lazy(() => import("./AbmComponents/Show")));
const Create = Loadable(lazy(() => import("./AbmComponents/Create")));

const routes = [
  {
    path: "formulasBase",
    element: <List config={config} />,
  },
  {
    path: "formulasBase/update/:id",
    element: <Update />,
  },
  {
    path: "formulasBase/create",
    element: <Create />,
  },
  {
    path: "formulasBase/show/:id",
    element: <Show />,
  },
];
export default routes;
